import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';

import CustomControl from '../../../../components/global/CustomControl';
import Button from '../../../../components/global/Button';
import RegisterViewDetailsForm from './RegisterViewDetailsForm';
import DismissButton from '../../../../components/global/DismissButton';

const propTypes = {
  values: PropTypes.shape({
    email_per_month: PropTypes.bool,
    sms_per_month: PropTypes.bool,
    social_post_per_month: PropTypes.bool,
    banner_on_website: PropTypes.bool,
    addon_for_online_purchases: PropTypes.bool,
  }),
  handleSubmit: PropTypes.func,
  handleChange: PropTypes.func,
  isValid: PropTypes.bool,
  onGoBack: PropTypes.func,
  validateForm: PropTypes.func,
  addonForOnlinePurchasesEnabled: PropTypes.bool,
};

const RegistrationFundraiserMarketingCommitment = ({
  values,
  handleSubmit,
  handleChange,
  isValid,
  onGoBack,
  validateForm,
  addonForOnlinePurchasesEnabled = true,
}) => {
  useEffect(() => {
    validateForm(values);
  }, [values]);

  return (
    <>
      <RegisterViewDetailsForm
        loading={false}
        handleChange={handleChange}
        requiresCreditCard={false}
        values={values}
        handleSubmit={handleSubmit}
      />
      <Modal
        ariaHideApp={false}
        isOpen
        bodyOpenClassName="body-modal-open"
        overlayClassName="modal-overlay"
        className="fundraiser-marketing-commitment-modal"
      >
        <div className="d-flex mb-1">
          <DismissButton className="ml-auto" onClick={onGoBack} />
        </div>
        <h2 className="text-center">
          Waldo School Fundraiser Marketing Commitment
        </h2>

        <p>
          By enrolling in Waldo&apos;s school fundraiser program, I agree in
          exchange for waiving the cost of Photo Manager and Photo Finder
          (regularly priced at $1,499 per year) that I will market Waldo Plus to
          the school&apos;s families via the following communications:
        </p>

        <CustomControl
          type="checkbox"
          id="email_per_month"
          name="email_per_month"
          label="1 email per month for 4 months (4 total)"
          onChange={handleChange}
          className="mb-1"
          checked={values.email_per_month}
        />
        <CustomControl
          type="checkbox"
          id="sms_per_month"
          name="sms_per_month"
          label="1 SMS message per month for 2 months (2 total)"
          onChange={handleChange}
          className="mb-1"
          checked={values.sms_per_month}
        />
        <CustomControl
          type="checkbox"
          id="social_post_per_month"
          name="social_post_per_month"
          label="1 social post on Instagram and Twitter per month for 4 months (4 total)"
          onChange={handleChange}
          className="mb-1"
          checked={values.social_post_per_month}
        />
        <CustomControl
          type="checkbox"
          id="banner_on_website"
          name="banner_on_website"
          label="1 banner on school's website"
          onChange={handleChange}
          className="mb-1"
          checked={values.banner_on_website}
        />
        {addonForOnlinePurchasesEnabled && (
          <CustomControl
            type="checkbox"
            id="addon_for_online_purchases"
            name="addon_for_online_purchases"
            label="Add-on for online yearbook purchases (automatically provided by PLIC)"
            className="mb-1"
            checked={values.addon_for_online_purchases}
            readOnly
          />
        )}
        <p className="mt-1">
          My school will receive 10% of net revenue for each new Waldo Plus
          subscription generated from this marketing.
        </p>

        <Button btnBlock onClick={handleSubmit} disabled={!isValid}>
          Activate Photo Manager &amp; connect to PLIC
        </Button>
      </Modal>
    </>
  );
};

RegistrationFundraiserMarketingCommitment.propTypes = propTypes;

export default RegistrationFundraiserMarketingCommitment;
